import { getV1CompaniesCompanyIdServices } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import connection from '~services/connectionModule';
import { useStores } from '~store';

import { Service } from './models';

export const useServices = () => {
  const { companyAssetsStore } = useStores();

  const getAllServices = async (companyId: string) => {
    try {
      const response = await getV1CompaniesCompanyIdServices({
        path: { 'company-id': companyId },
      });

      companyAssetsStore.setServices(response.data.data.map(Service.parse));
    } catch (error) {
      connection.handleRequestError(error, t('error_messages.services.failed_to_fetch'));
    }
  };

  return {
    getAllServices,
  };
};
